import { accessiblePhoneNumbersSelector } from "appredux/selectors";
import { useDispatch, useSelector } from "react-redux";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { setChat } from "appredux/chatSlice";
import { setSelectedPhoneNumber } from "appredux/configSlice";
import { first } from "lodash-es";

const useNavigateToHome = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const accessiblePhoneNumbers = useSelector(accessiblePhoneNumbersSelector);

  return useCallback(() => {
    const firstPhoneNumber = first(accessiblePhoneNumbers);
    if (firstPhoneNumber) {
      dispatch(setSelectedPhoneNumber(firstPhoneNumber));
      dispatch(setChat({ conversation: {}, messages: [] }));
      navigate(`/conversations/${firstPhoneNumber.id}/list`);
      return;
    }
    // Tidak ada channel yang boleh diakses, MainPage yang tentukan tujuannya
    navigate("/");
  }, [accessiblePhoneNumbers, dispatch, navigate]);
};

export default useNavigateToHome;
